import type {
    AbilityGrantedCreatureFlagProvider,
    AbilityGrantedCreatureFlagWrites,
    AbilityGrantedCreatureFlagsInput,
} from '../types';

const ROOT_FLAG_MAP = [
    ['ignoreSpellComponentVerbal', 'ignore_spell_component_verbal'],
    ['ignoreSpellComponentSomatic', 'ignore_spell_component_somatic'],
    ['ignoreSpellComponentMaterial', 'ignore_spell_component_material'],
    ['rangedWeaponAttacksIgnoreCover', 'ranged_weapon_attacks_ignore_cover'],
    ['rangedSpellAttacksIgnoreCover', 'ranged_spell_attacks_ignore_cover'],
    ['rangedAttacksIgnoreCover', 'ranged_attacks_ignore_cover'],
] as const satisfies readonly [
    keyof AbilityGrantedCreatureFlagProvider,
    keyof AbilityGrantedCreatureFlagWrites['root'],
][];

/**
 * Select the host writes contributed by condition- and level-approved feat/passive providers.
 * Provider discovery and gating stay outside this pure boundary.
 */
export function compileAbilityGrantedCreatureFlags(
    input: AbilityGrantedCreatureFlagsInput,
): AbilityGrantedCreatureFlagWrites {
    const root: AbilityGrantedCreatureFlagWrites['root'] = {};
    const computedMeta: AbilityGrantedCreatureFlagWrites['computedMeta'] = {};

    for (const provider of input.providers) {
        for (const [inputKey, outputKey] of ROOT_FLAG_MAP) {
            if (provider[inputKey]) root[outputKey] = [1];
        }
        if (provider.bodyVanishesAtZeroVitality) {
            computedMeta.body_vanishes_at_zero_vitality = 1;
        }
    }

    return { root, computedMeta };
}
